import React from 'react';
import './About.css';
import img from '../../img/jile3.jpg';

const About = () => {
  return (
    <section className="about" id="okompanii">
      <div className="about-overlay"></div>
      <div className="container">
        <div className="about-content">
          <div className="about-row">
            <div className="about-col about-col-image">
              {/* <div className="image-spacer"></div> */}
              <div className="about-image">
                <img src={img} alt="Комфортное проживание" />
              </div>
              <div className="image-spacer-small"></div>
            </div>
            
            <div className="about-col about-col-text">
              {/* <div className="text-spacer"></div> */}
              <div className="about-text-content">
                <div className="about-header">
                  <p className="about-pretitle">гостиница</p>
                  <h2 className="about-title">БЕЛАЯ</h2>
                  <p className="about-address">Правая Белая, 12</p>
                </div>
                
                <div className="text-spacer-medium"></div>
                
                <div className="about-description">
                  <p>
                    Проживание в комфортной мини гостинице для иностранцев и граждан России. 
                    Расположенная в малоэтажном жилом фонде Уфы, близ реки Белая, круглосуточно 
                    принимает иностранных мигрантов для предоставления жилья с пропиской и 
                    легализацией нахождения на территории Российской Федерации.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;